import { render, staticRenderFns } from "./splash-layout.vue?vue&type=template&id=67c3cca8&scoped=true&lang=pug&"
import script from "./splash-layout.vue?vue&type=script&lang=ts&"
export * from "./splash-layout.vue?vue&type=script&lang=ts&"
import style0 from "./splash-layout.vue?vue&type=style&index=0&id=67c3cca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c3cca8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
